import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from 'seagull';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { accountingIconMap } from '~/integrations/Accounting/AccountingIcon/accountingIconMap';
import { formatDateTimeWithShortMonth } from '~/utils/date-formatting';
const accountingName = (accountingType)=>getAccountingDetails(accountingType).fullName;
function getTooltip(integration, accountingType) {
    return integration.accept({
        whenPendingSync: ()=>"Pending invoice sync to ".concat(accountingName(accountingType)),
        whenInvoiceSyncFailed: ()=>"Invoice sync failed in ".concat(accountingName(accountingType)),
        whenPaymentSyncFailed: ()=>"Payment sync failed in ".concat(accountingName(accountingType)),
        whenRefundSyncFailed: ()=>"Refund sync failed in ".concat(accountingName(accountingType)),
        whenInvoiceRecorded: (param)=>{
            let { date } = param;
            return "Invoice recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
        },
        whenVoidedRecorded: (param)=>{
            let { date } = param;
            return "Invoice recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
        },
        whenRefundRecorded: (param)=>{
            let { date } = param;
            return "Refund recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
        },
        whenPaymentRecorded: (param)=>{
            let { date } = param;
            return "Payment recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
        }
    });
}
function getAccountingIcon(integration, accountingType) {
    const status = getInvoiceIntegrationStatus(integration);
    return status ? accountingIconMap[accountingType][status] : null;
}
function getInvoiceIntegrationStatus(integration) {
    if (integration.isSynced()) {
        return 'success';
    } else if (integration.isSyncFailed()) {
        return 'error';
    } else if (integration.isPendingSync()) {
        return 'pending';
    } else {
        return null;
    }
}
export function InvoiceAccountingIntegrationStatus(props) {
    const { className, testId, invoiceIntegration, placement = 'top', accountingType } = props;
    return invoiceIntegration ? /*#__PURE__*/ _jsx("div", {
        "data-testid": testId,
        className: className,
        children: /*#__PURE__*/ _jsx(Tooltip, {
            title: /*#__PURE__*/ _jsx("div", {
                "data-testid": "".concat(testId, "-tooltip"),
                children: getTooltip(invoiceIntegration, accountingType)
            }),
            placement: placement,
            children: /*#__PURE__*/ _jsx("span", {
                style: {
                    display: 'inline'
                },
                children: getAccountingIcon(invoiceIntegration, accountingType)
            })
        })
    }) : null;
}
